import React, { Component } from 'react'
import { Loading } from './'

class FullScreenLoading extends Component {
  render() {
    const { containerStyle } = styles
    const { show = false } = this.props
    if (!show) return null
    return (
      <div style={containerStyle}>
        <Loading />
      </div>
    )
  }
}

const styles = {
  containerStyle: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    zIndex: 2000,
    top: 0,
    left: 0
  }
}

export { FullScreenLoading }



// WEBPACK FOOTER //
// ./src/components/common/FullScreenLoading.js